import pikachu from "../../assets/pikachu.png";
import pokedex from "../../assets/pokedex.png";
import charmander from "../../assets/charmander.png";
import AppImage from "../AppImage/AppImage";
import "./index.css";

function Header() {
  return (
    <header className="hero-header">
      <AppImage src={charmander} alt="Charmander" className="hero-mascot hero-left" />

      <div className="hero-content">
        <p className="hero-badge">Pokédex React</p>
        <AppImage src={pokedex} alt="Pokedex" className="hero-logo" />
        <h1>Descubra, pesquise e compare Pokémons</h1>
        <p className="hero-subtitle">
          Navegue pela Pokédex com uma experiência rápida, moderna e responsiva.
        </p>
      </div>

      <AppImage src={pikachu} alt="Pikachu" className="hero-mascot hero-right" />
    </header>
  );
}

export default Header;
